import axios from "axios"

const baseUrl = process.env.GATSBY_API_URL || ""

export const searchByKeyword = (
  keyword: string,
  offset: number,
  pagesize: number
) => {
  return axios.get(
    `${baseUrl}/api/v1/public/postsearch?searchText=${keyword}&offset=${offset}&pagesize=${pagesize}`
  )
}

export const getByCategory = (
    category: string,
    offset: number,
    pagesize: number
) => {
    return axios.get(
        `${baseUrl}/api/v1/public/post/${category}?offset=${offset}&pagesize=${pagesize}`
    )
}


export const categories = [
  { name: "movie", label: "Movie & Series" },
  { name: "entertainment", label: "Entertainment" },
  { name: "sports", label: "Sports" },
  { name: "knowledge", label: "Knowledge" },
  { name: "news", label: "News" },
  { name: "kids", label: "Kids" },
]
